var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pesquisaContainer"},[_c('Login'),_c('span',[_vm._v(" "+_vm._s(_vm.usuario && _vm.usuario.codUsuario > 0 ? _vm.$router.push('/home') : '')+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }